import {
  GoogleLoginProvider,
  SocialAuthService,
} from '@abacritt/angularx-social-login';
import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { LoginByGoogleService } from '@features/auth/core/domain/login/login-by-google.service';
import { provideSocialAuthServiceConfig } from '../../../login-by-google.provider';
import { AccountSettingService } from '@features/auth/core/domain/account/account-setting.service';
import { ToastrService } from '@shared/components/lib-ngx/ngx-toastr/toastr/toastr.service';
import {
  Subject,
  takeUntil,
  from,
  tap,
  switchMap,
  finalize,
  Observable,
} from 'rxjs';
import Swal from 'sweetalert2';
import { ContactLoginMethodDTO } from '@features/auth/core/domain/account/model/user-info.model';

@Component({
  standalone: true,
  imports: [CommonModule],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useFactory: provideSocialAuthServiceConfig,
    },
    SocialAuthService,
    LoginByGoogleService,
  ],
  selector: 'app-link-thirt-party-account',
  templateUrl: './link-thirt-party-account.component.html',
  styleUrls: ['./link-thirt-party-account.component.scss'],
})
export class LinkThirtPartyAccountComponent implements OnInit {
  service = inject(AccountSettingService);

  constructor() {}

  public googleService = inject(SocialAuthService);
  public toast = inject(ToastrService);

  public destroy$$ = new Subject<void>();
  public accessToken: string = '';

  // UI variablew
  public isWaitingForLogin: boolean = false;
  public waitingForLoadComponentData: boolean = false;
  public isWatingForSendTokenToServer: boolean = false;

  linkedMethod: Array<ContactLoginMethodDTO> = [];

  isLoading = false;
  onReload = new Subject<void>();

  ngOnInit() {
    this.googleService.initState.pipe(takeUntil(this.destroy$$)).subscribe({
      next: (value) => {
        this.waitingForLoadComponentData = value;
      },
    });
    this.load();
  }

  ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.complete();
  }

  load() {
    this.isLoading = true;
    this.service
      .getListLoginMethod()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (value) => {
          this.linkedMethod = value;
        },
      });
  }

  async onLinkGoogleAccount() {
    if (this.isWatingForSendTokenToServer) {
      return;
    }

    this.isWaitingForLogin = true;

    from(this.googleService.getAccessToken(GoogleLoginProvider.PROVIDER_ID))
      .pipe(
        tap((token) => {
          this.accessToken = token;
          this.isWatingForSendTokenToServer = true;
        }),
        switchMap((accessToken) => {
          return this.service.linkGoogle(accessToken);
        }),
        finalize(() => {
          this.isWatingForSendTokenToServer = false;
          this.isWaitingForLogin = false;
        })
      )
      .subscribe({
        next: (value) => {
          this.load();
          Swal.fire({
            title: 'Liên kết tài khoản google thành công! ',
            text: 'Bây giờ bạn có thể đăng nhập vào hệ thống bằng tài khoản google vừa liên kết',
            icon: 'success',
            confirmButtonText: 'Ok! Tôi hiểu rồi',
          });
        },
        error: (err) => {
          Swal.fire({
            title: 'Lỗi liên kết tài khoản google',
            text: err.message,
            icon: 'error',
            confirmButtonText: 'Ok! Tôi hiểu rồi',
          });
        },
      });
  }

  unLinkgoogleAccount() {
    // SHow confirm
    from(
      Swal.fire({
        title: 'Hủy liên kết tài khoản google?',
        text: 'Bạn có chắc muốn hủy liên kết tài khoản google?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
      })
    ).subscribe({
      next: (value) => {
        if (!value.isConfirmed) {
          return;
        }
        this.service.unlinkGoogle().subscribe({
          next: (value) => {
            this.load();
            Swal.fire({
              title: 'Hũy liên kết  tài khoản google thành công! ',
              text: 'Bây giờ bạn không thể đăng nhập vào hệ thống bằng tài khoản google này',
              icon: 'success',
              confirmButtonText: 'Ok! Tôi hiểu rồi',
            });
            this.onReload.next();
          },
          error: (err) => {
            Swal.fire({
              title: 'Lỗi hũy liên kết tài khoản google',
              text: err.message,
              icon: 'error',
              confirmButtonText: 'Ok! Tôi hiểu rồi',
            });
          },
        });
      },
    });
  }
}
